import { checkboxMediaInput } from '@utils/component-framework';
import { PostloadedImage } from '@utils/react';
import { useOpgavekompleksetEntry } from '../../../../state/hook.entry.js';
import { useUpdateInputMutation } from '../../../../state/mutations/update-input.js';
import { CircledAudioPlayer } from '../../../atom.audio/_audio-player.circled.js';
import { useInputState } from '../../hook.use-input-state.js';
import { MediaBox } from '../atom.media-box/_media-box.js';
import { image, audioPlayer } from './input.image.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function ImageInput(props) {
  const update = useUpdateInputMutation();
  const inputEntry = useOpgavekompleksetEntry({
    select: entry => checkboxMediaInput.entry.asType(entry?.data.tasks[props.taskEntryKey]?.details[props.node.id])
  });
  const onChange = () => {
    update(props.taskEntryKey, props.node.id, {
      type: "checkbox-media",
      markedAsCorrectAnswer: !inputEntry?.markedAsCorrectAnswer
    });
  };
  const baseState = useInputState(props.node, inputEntry);
  const state = (() => {
    if (baseState === "incorrect" && !inputEntry?.markedAsCorrectAnswer && props.node.correctAnswer) {
      return "should-have";
    }
    return baseState;
  })();
  return /*#__PURE__*/jsxs(MediaBox, {
    state: state,
    checked: !!inputEntry?.markedAsCorrectAnswer,
    onChange: onChange,
    orientation: props.orientation,
    theme: "squared",
    allowClickOnBox: true,
    children: [/*#__PURE__*/jsx(PostloadedImage, {
      className: image,
      alt: props.node.altText ?? "",
      src: props.node.src,
      onReady: img => {
        const aspect = img ? img.naturalWidth / img.naturalHeight : 1;
        img?.style.setProperty("width", `${Math.min(200, img.naturalHeight) * aspect}px`);
      }
    }), props.node.audioSrc && /*#__PURE__*/jsx(CircledAudioPlayer, {
      className: audioPlayer,
      src: props.node.audioSrc
    })]
  });
}

export { ImageInput };
//# sourceMappingURL=input.image.js.map
